// extracted by mini-css-extract-plugin
export default {"spacing":"Spacing_spacing__s39EK"};